<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :stroke="stroke"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="kiosk-icon"
  >
    <!-- Back -->
    <polyline
      v-if="name === 'back'"
      points="15 18 9 12 15 6"
    />

    <!-- Close / X -->
    <g v-else-if="name === 'close'">
      <line
        x1="18"
        y1="6"
        x2="6"
        y2="18"
      />
      <line
        x1="6"
        y1="6"
        x2="18"
        y2="18"
      />
    </g>

    <!-- Placeholder / Image -->
    <g v-else-if="name === 'placeholder'">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        ry="2"
      />
      <circle
        cx="8.5"
        cy="8.5"
        r="1.5"
      />
      <polyline points="21 15 16 10 5 21" />
    </g>

    <!-- Checkmark -->
    <polyline
      v-else-if="name === 'check'"
      points="20 6 9 17 4 12"
    />

    <!-- Minus -->
    <line
      v-else-if="name === 'minus'"
      x1="5"
      y1="12"
      x2="19"
      y2="12"
    />

    <!-- Plus -->
    <g v-else-if="name === 'plus'">
      <line
        x1="12"
        y1="5"
        x2="12"
        y2="19"
      />
      <line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
      />
    </g>

    <!-- Chevron Right -->
    <polyline
      v-else-if="name === 'chevronRight'"
      points="9 18 15 12 9 6"
    />

    <!-- Chevron Down -->
    <polyline
      v-else-if="name === 'chevronDown'"
      points="6 9 12 15 18 9"
    />

    <!-- All Items (Grid) -->
    <g v-else-if="name === 'all-items'">
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
      />
    </g>

    <!-- Dine In -->
    <g v-else-if="name === 'dine'">
      <path d="M3 12h18M3 6h18M3 18h18" />
    </g>

    <!-- Take Out -->
    <g v-else-if="name === 'take'">
      <path
        d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      />
      <rect
        x="8"
        y="2"
        width="8"
        height="4"
        rx="1"
        ry="1"
      />
    </g>

    <!-- Generic / Location -->
    <g v-else-if="name === 'generic'">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle
        cx="12"
        cy="10"
        r="3"
      />
    </g>

    <!-- Cart / Bag -->
    <g v-else-if="name === 'cart'">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
      <line
        x1="3"
        y1="6"
        x2="21"
        y2="6"
      />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </g>

    <!-- Trash -->
    <g v-else-if="name === 'trash'">
      <polyline points="3 6 5 6 21 6" />
      <path
        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      />
    </g>

    <!-- Note / Message -->
    <g v-else-if="name === 'note'">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <line
        x1="9"
        y1="10"
        x2="15"
        y2="10"
      />
      <line
        x1="9"
        y1="14"
        x2="15"
        y2="14"
      />
    </g>

    <!-- Checkout / Card -->
    <g v-else-if="name === 'checkout'">
      <rect
        x="1"
        y="4"
        width="22"
        height="16"
        rx="2"
        ry="2"
      />
      <line
        x1="1"
        y1="10"
        x2="23"
        y2="10"
      />
    </g>

    <!-- Info -->
    <g v-else-if="name === 'info'">
      <circle
        cx="12"
        cy="12"
        r="10"
      />
      <line
        x1="12"
        y1="16"
        x2="12"
        y2="12"
      />
      <line
        x1="12"
        y1="8"
        x2="12.01"
        y2="8"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "KioskIcon",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
    strokeWidth: {
      type: [String, Number],
      default: 2,
    },
  },
};
</script>

<style scoped>
.kiosk-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
